import BaekSang from '../../assets/images/Booth/TimeTable/Baeksang.png';
import MoongGe from '../../assets/images/Booth/TimeTable/Moonge.png';
import Odc from '../../assets/images/Booth/TimeTable/Odc.png';
import EumSam from '../../assets/images/Booth/TimeTable/EumSam.png';
import Ajax from '../../assets/images/Booth/TimeTable/Ajax.png';
import DooDoomChit from '../../assets/images/Booth/TimeTable/DooDoomChit.png';
import Arirang from '../../assets/images/Booth/TimeTable/Arirang.png';
import LikeLionDefault from '../../assets/images/Booth/TimeTable/LikeLionDefault.png';
import MokMyukSeong from '../../assets/images/Booth/TimeTable/MokMyukSeong.png';
import PeerlessDun from '../../assets/images/Booth/TimeTable/PeerlessDun.png';

export const clubData9 = [
  {
    id: 1,
    name: 'DUSSA',
  },
  {
    id: 2,
    name: '수중탐험연구회',
  },
  {
    id: 3,
    name: '카페인',
  },
  {
    id: 4,
    name: 'LOTUS',
  },
  {
    id: 5,
    name: 'E.L.F',
  },
  {
    id: 6,
    name: '프론티어',
  },
  {
    id: 7,
    name: '음샘',
  },
  {
    id: 8,
    name: 'AJAX',
  },
  {
    id: 9,
    name: '만화얼',
  },
  {
    id: 10,
    name: 'KCC',
  },
  {
    id: 11,
    name: '페인터즈',
  },
  {
    id: 12,
    name: 'UNSA',
  },
  {
    id: 13,
    name: '바람소리',
  },
  {
    id: 14,
    name: 'MECS',
  },
  {
    id: 15,
    name: '한글학교 하람',
  },
];

export const clubData10 = [];

export const testingData9 = [
  {
    id: 1,
    name: 'DUSSA',
  },
  {
    id: 15,
    name: '한글학교하람',
  },
  {
    id: 30,
    name: '멋쟁이사자처럼',
  },
  {
    id: 45,
    name: 'DUTC',
  },
  {
    id: 71,
    name: '디파트',
  },
  {
    id: 53,
    name: '동불',
  },
  {
    id: 60,
    name: 'FC 엘레펜테',
  },
];

export const testingData10 = [
  {
    id: 1,
    name: 'FC TOTO',
  },
  {
    id: 15,
    name: '디파트',
  },
  {
    id: 30,
    name: '멋쟁이사자처럼',
  },
  {
    id: 45,
    name: 'DUTC',
  },
  {
    id: 71,
    name: 'X',
  },
  {
    id: 53,
    name: '동불',
  },
  {
    id: 60,
    name: '동당동',
  },
];

export const TIME_DATA_THU = [
  {
    id: 1,
    logo: `${BaekSang}`,
    starttime: '13:00',
    endtime: '13:30',
    club: '백상액션',
  },
  {
    id: 2,
    logo: `${MoongGe}`,
    starttime: '13:30',
    endtime: '14:00',
    club: '뭉게구름',
  },
  {
    id: 3,
    logo: `${BaekSang}`,
    starttime: '14:00',
    endtime: '14:30',
    club: '백상밴드',
  },
  {
    id: 4,
    logo: `${LikeLionDefault}`,
    starttime: '14:30',
    endtime: '15:00',
    club: '잼잼',
  },
  {
    id: 5,
    logo: `${LikeLionDefault}`,
    starttime: '15:00',
    endtime: '15:30',
    club: '렛츠무드',
  },
  {
    id: 6,
    logo: `${Odc}`,
    starttime: '15:30',
    endtime: '16:00',
    club: 'ODC',
  },
  {
    id: 7,
    logo: `${EumSam}`,
    starttime: '16:00',
    endtime: '16:30',
    club: '음샘',
  },
  {
    id: 8,
    logo: `${Ajax}`,
    starttime: '16:30',
    endtime: '17:00',
    club: 'AJAX',
  },
  {
    id: 9,
    logo: `${DooDoomChit}`,
    starttime: '17:00',
    endtime: '17:30',
    club: '두둠칫',
  },
  {
    id: 10,
    logo: `${Arirang}`,
    starttime: '17:30',
    endtime: '18:00',
    club: '아리랑',
  },
];

export const TIME_DATA_FRI = [
  {
    id: 1,
    logo: `${BaekSang}`,
    starttime: '12:00',
    endtime: '12:30',
    club: '백상밴드',
  },
  {
    id: 2,
    logo: `${BaekSang}`,
    starttime: '12:30',
    endtime: '13:00',
    club: '백상액션',
  },
  {
    id: 3,
    logo: `${LikeLionDefault}`,
    starttime: '13:00',
    endtime: '13:30',
    club: '잼잼',
  },
  {
    id: 4,
    logo: `${MoongGe}`,
    starttime: '13:30',
    endtime: '14:00',
    club: '뭉게구름',
  },
  {
    id: 5,
    logo: `${MokMyukSeong}`,
    starttime: '14:00',
    endtime: '14:30',
    club: '목멱성',
  },
  {
    id: 6,
    logo: `${Odc}`,
    starttime: '14:30',
    endtime: '15:00',
    club: 'ODC',
  },
  {
    id: 7,
    logo: `${PeerlessDun}`,
    starttime: '15:00',
    endtime: '15:30',
    club: '피어리스던',
  },
  {
    id: 8,
    logo: `${Arirang}`,
    starttime: '15:30',
    endtime: '16:00',
    club: '아리랑',
  },
  {
    id: 9,
    logo: `${LikeLionDefault}`,
    starttime: '16:00',
    endtime: '16:30',
    club: '렛츠무드',
  },
  {
    id: 10,
    logo: `${Ajax}`,
    starttime: '16:30',
    endtime: '17:00',
    club: 'AJAX',
  },
  {
    id: 11,
    logo: `${DooDoomChit}`,
    starttime: '17:00',
    endtime: '17:30',
    club: '두둠칫',
  },
  {
    id: 12,
    logo: `${EumSam}`,
    starttime: '17:30',
    endtime: '18:00',
    club: '음샘',
  },
];
